import { defineMessages } from "react-intl";

export const scope =
  "components.AlpacaActivitiesScroll.components.AlpacaActivityDetails";

export const messages = defineMessages({
  asset: {
    id: `${scope}.asset`,
    defaultMessage: "Activo",
  },
  amount: {
    id: `${scope}.amount`,
    defaultMessage: "Monto",
  },
  fee: {
    id: `${scope}.fee`,
    defaultMessage: "Comisión",
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: "Estado",
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: "Fecha",
  },
  received: {
    id: `${scope}.received`,
    defaultMessage: "Recibiste",
  },
  sended: {
    id: `${scope}.sended`,
    defaultMessage: "Enviaste",
  },
  tid: {
    id: `${scope}.tid`,
    defaultMessage: "ID Movimiento",
  },
});
